import { RestSlice } from '../../../../redux/rest.slice';
import { CleaningEvent } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const cleaningSlice = new RestSlice<CleaningEvent>(
	localizationService.getLocalizedString('pumpout.cleaning'),
	Resource.Cleanings
);
export default cleaningSlice.rests.reducer;
